import React from 'react'
import Helmet from 'react-helmet'

import { getRSSFeeds } from '../../../common/utils/siteConfig'
import buildCanonicalPath from '../../../common/utils/buildCanonicalPath'
import siteConfigs from '../../../config/sites'
import siteConfigMenus from '../../../config/sites/menus'

export default ({
  seoMeta,
  location,
  currentSite,
  noIndex,
  baseUrl
}) => {
  const title = seoMeta.title || ''
  const description = seoMeta.meta_description || seoMeta.description || ''
  const siteConfig = siteConfigs[currentSite]

  // Defining meta tags
  let meta = [
    { name: 'description', content: description },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description }
  ]

  // set no index header
  if (noIndex) {
    meta.push({name: 'robots', content: 'noindex'})
  }

  let canonicalPath = buildCanonicalPath(currentSite, location)

  meta.push({ property: 'og:url', content: baseUrl + canonicalPath })
  // Defining link tags
  const link = [
    { rel: 'canonical', href: baseUrl + canonicalPath }
  ]

  // Define extra scripts
  const script = [
    {
      type: 'application/ld+json',
      innerHTML: `{
        "@context": "http://schema.org",
        "@type": "WebSite",
        "name": "${siteConfig.name}",
        "url": "${baseUrl}"
      }`
    }
  ]

  // rss feeds links
  const menuConfig = siteConfigMenus[currentSite]
  const RSSFeeds = getRSSFeeds(currentSite, menuConfig, siteConfig.feeds_categories || [])
  if (RSSFeeds.length) {
    RSSFeeds.forEach((feed) => {
      link.push({
        rel: 'alternate',
        type: 'application/atom+xml',
        href: feed.url,
        title: feed.title
      })
    })
  }

  return (
    <Helmet
      title={title}
      defaultTitle='Envato Market'
      meta={meta}
      link={link}
      script={script}
    />
  )
}



// WEBPACK FOOTER //
// ./client/components/siteMeta/siteMeta.js